import { DefaultApi } from './api';
import { OnboardingLinkResponse } from './types';

export const getByUuid = (uuid: string) =>
  DefaultApi.request<OnboardingLinkResponse>(
    `/onboarding-nca/${encodeURIComponent(uuid)}`,
    {
      method: 'GET',
    }
  );
